import { useBreakpoint } from '$hooks/index';
import {
  getAssetFromAssetList,
  getAssetProps,
  getSourceFromFields,
  responsiveContentfulSrcset,
} from '$providers/Assets/index';
import cn from 'classnames';
import { ImgHTMLAttributes } from 'react';

import ReactPlayer from '../ReactPlayer/src/index';
import { IAsset } from './';

export function StandardAsset(props: IAsset & ImgHTMLAttributes<HTMLElement>) {
  const {
    className,
    style = {},
    sizes = '100vw',
    assets = [],
    overlay,
    customClass = 'w-full h-full object-cover',
  } = props;
  const [breakpoint] = useBreakpoint();
  const overlayStyles = {
    'Black 40%': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.4)' /* Black with 40% opacity */,
      zIndex: 1 /* Ensure it's above the image but below other content */,
    },
    Gradient: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background:
        'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.64))' /* Gradient from transparent to black */,
      zIndex: 1 /* Ensure it's above the image but below other content */,
    },
    'Black 40% and Gradient': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background:
        'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.64))' /* Black with 40% opacity */,
      zIndex: 1 /* Ensure it's above the image but below other content */,
    },
  };

  if (!breakpoint) return null;

  const asset = getAssetFromAssetList({ assets, breakpoint });
  const assetSource = getSourceFromFields({ asset });

  if (
    assetSource.assetType === 'image' &&
    assetSource.assetOrigin === 'contentful'
  )
    return (
      <>
        <img
          width={getAssetProps(assetSource.image).width}
          height={getAssetProps(assetSource.image).height}
          style={style}
          alt={getAssetProps(assetSource.image).description || ''}
          sizes={sizes}
          srcSet={responsiveContentfulSrcset({ url: assetSource.url })}
          className={cn(customClass, className)}
          loading="lazy"
        />
        {overlayStyles[overlay] && <div style={overlayStyles[overlay]} />}
      </>
    );
  else if (
    assetSource.assetType === 'image' &&
    assetSource.assetOrigin === 'external'
  )
    return (
      <>
        <img
          id={overlay}
          style={style}
          alt={''}
          sizes={sizes}
          srcSet={assetSource.imageUrl}
          className={cn(customClass, className)}
          loading="lazy"
        />
        {overlayStyles[overlay] && <div style={overlayStyles[overlay]} />}
      </>
    );
  else if (
    assetSource.assetType === 'video' &&
    assetSource.assetOrigin === 'contentful'
  )
    return (
      <ReactPlayer
        url={assetSource.url}
        className={cn(customClass, className)}
        autoPlay={assetSource.autoplay}
        width={'100%'}
        height={'100%'}
        playing={assetSource.autoplay}
        controls={assetSource.controls}
        loop={assetSource.loop}
        muted={assetSource.muted}
        playsinline={true}
        config={{
          file: {
            hlsOptions: {
              startLevel: 4,
            },
          },
        }}
      />
    );
  else if (
    assetSource.assetType === 'video' &&
    assetSource.assetOrigin === 'external'
  )
    return (
      <ReactPlayer
        url={assetSource.url}
        className={cn(customClass, className)}
        autoPlay={assetSource.autoplay}
        width={'100%'}
        height={'100%'}
        playing={assetSource.autoplay}
        controls={assetSource.controls}
        loop={assetSource.loop}
        muted={assetSource.muted}
        playsinline={true}
        config={{
          file: {
            hlsOptions: {
              startLevel: 4,
            },
          },
        }}
      />
    );

  return null;
}
